import React, { useEffect, useState } from 'react';
import { GoogleMap, useJsApiLoader, StreetViewPanorama } from '@react-google-maps/api';
import { GMAPS_LIBRARIES } from '@util/customHooks/useLocationToGeoCode';

interface GalleryStreetViewProps {
  streetViewData: {
    lat: number;
    lng: number;
  };
  isStreetViewAvailable: boolean;
}

import { ModalInnerWrapper, Loading } from './styles';

const GalleryStreetView = ({ streetViewData, isStreetViewAvailable }: GalleryStreetViewProps) => {
  const config = {
    google: {
      mapKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY!,
    },
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: config.google.mapKey,
    libraries: GMAPS_LIBRARIES,
  });

  const streetViewPanoramaOptions: google.maps.StreetViewPanoramaOptions = {
    position: streetViewData,
    visible: true,
  };

  return isLoaded && isStreetViewAvailable ? (
    <ModalInnerWrapper>
      <GoogleMap
        mapContainerStyle={{
          height: '100%',
          width: '100%',
        }}
        zoom={7}
        center={streetViewData}
      >
        <StreetViewPanorama options={streetViewPanoramaOptions} />
      </GoogleMap>
    </ModalInnerWrapper>
  ) : (
    <Loading>
      <p>Loading...</p>
    </Loading>
  );
};

export default GalleryStreetView;
